if (!customElements.get("product-request-information")) {
  customElements.define(
    "product-request-information",
    class ProductRequestInformation extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.collapsed = this.getAttribute("expanded") === "false";
        this.toggleElement = this.querySelector(".product-request-information-toggle");
        this.contentElement = this.querySelector(".product-request-information-content");
        this.onToggle = this.onToggle.bind(this);
        this.onKeyup = this.onKeyup.bind(this);
        this.toggleElement.addEventListener("click", this.onToggle);

        this.querySelector("[data-request-information-close]")?.addEventListener("click", () => {
          this.collapse();
        });

        this.contentElement?.addEventListener("mousedown", (event) => {
          if (event.target === this.contentElement) {
            this.collapse();
          }
        });

        this.addEventListener("keyup", this.onKeyup);

        if (!this.collapsed) {
          document.body.classList.add("overflow-hidden");
        }
      }

      onToggle(event) {
        event.preventDefault();
        this.handleToggle();
      }

      onKeyup(event) {
        if (event.code.toUpperCase() === "ESCAPE" && !this.collapsed) {
          this.collapse();
        }
      }

      collapse() {
        this.setAttribute("expanded", "false");
        this.toggleElement.setAttribute("aria-expanded", "false");
        this.collapsed = true;
        document.body.classList.remove("overflow-hidden");
      }

      expand() {
        this.setAttribute("expanded", "true");
        this.toggleElement.setAttribute("aria-expanded", "true");
        this.collapsed = false;
        document.body.classList.add("overflow-hidden");
        this.querySelector('input[name="contact[name]"]')?.focus();
      }

      handleToggle() {
        if (this.collapsed) {
          this.expand();
        } else {
          this.collapse();
        }
      }
    },
  );
}